import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Typography } from 'antd';

import './section.css';
import moment from 'moment';

const { Text } = Typography;

const leftSectionLayout = {
	sm: { span: 12 },
	lg: { span: 6 },
};

const rightSectionLayout = {
	sm: { span: 12 },
	lg: { span: 10 },
};

function SummarySection(props) {
  const {
    givenName,
    nameSuffix,
    lastName,
    middleName,
    dateOfBirth,
    sex,
	patientID
  } = props.personalInfo;
  
  const {
    bed,
    chargeSlip,
    comment,
    locationName,
    patientAge,
    physicianName,
    visit,
    officialReceipt,
  } = props.otherInfo;

 const requestDate =  moment().format("MM-DD-YYYY HH:MM:SS");

		return (
			<div className="request-summary">
				<Row justify="center" style={{marginLeft: 80, marginTop: 30}}>
					<Col sm={10} /*lg={{ span: 18, offset: 3 }}*/>
						
						<Row >
							<Col {...leftSectionLayout}>
								<Text strong>PATIENT NAME</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{`${givenName} ${(middleName === undefined || middleName === null ? '' : middleName)} ${lastName} ${nameSuffix || ''}`}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>DATE OF BIRTH</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{`${dateOfBirth} - ${patientAge} YEARS OLD`}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>GENDER</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{sex.toString().toUpperCase()}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>WARD/ROOM</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{locationName.toString().toUpperCase()}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>PATIENT ID</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{patientID}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>COMMENT</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{comment ? comment.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
					</Col>
					<Col sm={10} /*lg={{ span: 18, offset: 3 }}*/>
					<Row>
							<Col {...leftSectionLayout}>
								<Text strong>REQUEST DATE</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{requestDate}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>PHYSICIAN</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{physicianName ? physicianName.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>BED</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{bed ? bed.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>VISIT</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{visit ? visit.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>CHARGE SLIP</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{chargeSlip ? chargeSlip.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>OFFICIAL RECEIPT</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{officialReceipt ? officialReceipt.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
					</Col>
					{/* <Col style={{marginLeft: "8.2%", width: "100%"}}>
						<Text strong>COMMENT</Text> 
						<Text style={{marginLeft: "5%"}}>{comment ? comment.toString().toUpperCase() : '----'}</Text>
					</Col> */}
				</Row>
			</div>
		);
	}

SummarySection.propTypes = {
  personalInfo: PropTypes.shape({
    givenName: PropTypes.string,
    nameSuffix: PropTypes.string,
    lastName: PropTypes.string,
    middleName: PropTypes.string,
    dateOfBirth: PropTypes.string,
    sex: PropTypes.string
  }).isRequired,
  otherInfo: PropTypes.shape({
    bed: PropTypes.string,
    chargeSlip: PropTypes.string,
    comment: PropTypes.string,
    locationName: PropTypes.string,
    patientAge: PropTypes.string,
    physicianName: PropTypes.string,
    visit: PropTypes.string
  }).isRequired
};

export default SummarySection;
